import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ProvidersVisibilityService } from '../../services/providers-visibility.service';
import { TndPagesVisibilityService } from '../../services/tnd-pages-visibility.service';

@Component({
  selector: 'app-left-sidenav',
  templateUrl: './left-sidenav.component.html',
  styleUrls: ['./left-sidenav.component.scss']
})
export class LeftSidenavComponent implements OnInit {

  @Output() closeLeftSidenav = new EventEmitter();

  // The payments guide entry only shows for logged-in TND accounts.
  canSeeTndPayments$ = this.tndVisibility.canSeeTndPayments$;

  // The virtuals lobby entry: the two kill switches AND the server's
  // per-account verdict for the signed-in account — the same rule
  // ProvidersEnabledGuard enforces on the route, shared with the header
  // through one stream (ProvidersVisibilityService).
  canSeeVirtuals$ = this.providersVisibility.canSeeVirtuals$;

  constructor(
    public router: Router,
    private tndVisibility: TndPagesVisibilityService,
    private providersVisibility: ProvidersVisibilityService,
  ) { }

  ngOnInit(): void {
  }

}
